import { render, staticRenderFns } from "./templateD.vue?vue&type=template&id=180f0c67&scoped=true"
import script from "./templateD.vue?vue&type=script&lang=js"
export * from "./templateD.vue?vue&type=script&lang=js"
import style0 from "./templateD.vue?vue&type=style&index=0&id=180f0c67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f0c67",
  null
  
)

export default component.exports